import UserAdd from './UserAdd';

export default UserAdd;
